import React from 'react'
import { Helmet } from "react-helmet"
import { Link, graphql } from 'gatsby'
import Img from "gatsby-image"
import Seo from '../components/seo'
import NavMobile from '../components/nav_mobile'
import BackgroundImage from 'gatsby-background-image'
import GoogleReviews from '../components/google_reviews_slider'
import Copyright from '../components/copyright'
import Partners from '../components/partners'

export default ({ data }) => {
    const entry = data.markdownRemark
    const { frontmatter } = entry
    const heroFluid = frontmatter.image?.childImageSharp?.fluid
    const sideFluid = frontmatter.side_image?.childImageSharp?.fluid
    const titleBlock = (
        <div className="title__gradient">
            <div className="layout__container">
                <div className="layout__wide title center">
                    <h1>{frontmatter.heading}</h1>
                </div>
            </div>
        </div>
    )



    return (
        <div className="page">
            <Helmet>
                <link href="https://fonts.googleapis.com/css2?family=Oswald&display=swap" rel="stylesheet" />
                <style>{`
                    .local-page .layout__container {
                        max-width: 1400px; /* Increase container max-width for local pages */
                    }
                    .local-page .layout__wide {
                        width: 100% !important; /* Override ux.css width: 85% on mobile */
                        max-width: 1600px;
                        padding: 0 15px !important; /* Mobile padding */
                        box-sizing: border-box !important; /* Fix mobile horizontal gap */
                    }
                    @media only screen and (min-width: 768px) {
                        .local-page .layout__wide {
                            padding: 0 40px !important; /* Desktop padding */
                        }
                    }
                    @media only screen and (min-width: 960px) {
                        .local-page .grid__2-1 {
                            grid-template-columns: 3fr 1fr; /* Make left grid even wider */
                        }
                    }
                    .local-content .gatsby-resp-image-wrapper {
                        max-height: 500px !important;
                        overflow: hidden !important;
                    }
                    .local-content img {
                        max-height: 500px !important;
                        object-fit: cover !important;
                    }
                    @media only screen and (max-width: 768px) {
                        .local-content .gatsby-resp-image-wrapper,
                        .local-content p > img,
                        .local-content img:not(.gatsby-resp-image-image) {
                            width: 85% !important;
                            max-width: 350px !important;
                            float: none !important;
                            margin: 20px auto !important;
                            display: block !important;
                            clear: both !important;
                            position: relative !important;
                            left: 0 !important;
                            right: 0 !important;
                        }
                    }
                    @media only screen and (min-width: 769px) {
                        .local-content .gatsby-resp-image-wrapper,
                        .local-content img:not(.gatsby-resp-image-image) {
                            width: 45% !important;
                            min-width: 250px !important;
                            margin-top: 10px !important;
                            margin-bottom: 20px !important;
                            display: block !important;
                        }
                        .local-content p:nth-of-type(odd) .gatsby-resp-image-wrapper,
                        .local-content p:nth-of-type(odd) img:not(.gatsby-resp-image-image),
                        .local-content img:not(.gatsby-resp-image-image):nth-of-type(odd) {
                            float: right !important;
                            margin-left: 30px !important;
                            margin-right: 0 !important;
                        }
                        .local-content p:nth-of-type(even) .gatsby-resp-image-wrapper,
                        .local-content p:nth-of-type(even) img:not(.gatsby-resp-image-image),
                        .local-content img:not(.gatsby-resp-image-image):nth-of-type(even) {
                            float: left !important;
                            margin-right: 30px !important;
                            margin-left: 0 !important;
                        }
                    }
                `}</style>
            </Helmet>
            <Seo title={frontmatter.page_title} description={frontmatter.meta_description} image="" pathname={entry.fields.slug} />
            <NavMobile />
            <div className="layout">
                {heroFluid ? (
                    <BackgroundImage fluid={heroFluid} backgroundColor={`#ffffff`}>
                        {titleBlock}
                    </BackgroundImage>
                ) : (
                    <div style={{ position: 'relative' }}>
                        {frontmatter.image && (
                            <img
                                src={frontmatter.image.publicURL || (typeof frontmatter.image === 'string' ? frontmatter.image : '')}
                                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', zIndex: -1 }}
                                alt={frontmatter.heading}
                            />
                        )}
                        {titleBlock}
                    </div>
                )}
            </div>
            <div className="layout grey local-page">
                <div className="layout__container">
                    <div className="layout__wide">
                        <nav className="breadcrumb">
                            <p><Link to='/'>Home</Link> &nbsp;&rsaquo;&nbsp; <Link to={`/${frontmatter.section_url}/`}>{frontmatter.section}</Link> &nbsp;&rsaquo;&nbsp; <strong>{frontmatter.title}</strong></p>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="layout body local-page">
                <div className="layout__container">
                    <div className="layout__wide">
                        <div className="grid grid__2-1 grid__gap--48 text">
                            <div className="local-content">
                                <div dangerouslySetInnerHTML={{ __html: entry.html }} />
                                <Link to="/contact" title="Contact" className="btn btn__large btn__margin">Request quote &nbsp;►</Link>

                            </div>
                            <div className="aside">
                                {sideFluid && (
                                    <Img fluid={sideFluid} alt={frontmatter.side_heading || ''} />
                                )}
                                {frontmatter.side_heading && <h3>{frontmatter.side_heading}</h3>}
                                <ul>
                                    {(frontmatter.side_text ?? []).map((item, i) => (
                                        <li key={i}>{item.text}</li>
                                    ))}
                                </ul>
                                <figure className="master_painter">
                                    <a href="https://www.masterpainters.co.nz/" title="Master Painters" rel="nofollow noopener"><Img fixed={data.master_painter.childImageSharp.fixed} alt='Master Painter' /></a>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GoogleReviews />
            <Partners />
            <Copyright />
        </div>
    )
}

export const query = graphql`
	query($slug: String!) {
        master_painter: file(relativePath: { eq: "MP_Logo.jpg" }) {
            childImageSharp {
                fixed(width: 200) {
                    ...GatsbyImageSharpFixed
                  }
            }
        }
		markdownRemark( fields: { slug: { eq: $slug } }) {
			frontmatter {
                section
                section_url
                title
				page_title
                meta_description
                heading
                image {
                    publicURL
                    childImageSharp {
                        fluid(maxWidth: 1280) {
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
                side_heading
                side_text {
                    text
                }
                side_image {
                    childImageSharp {
                        fluid(maxWidth: 640, maxHeight: 480) {
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
			}
			fields {
				slug
			}
			html
		}
	}
`
